import { render } from "./RenameTaskModal.vue?vue&type=template&id=41b56560&scoped=true"
import script from "./RenameTaskModal.vue?vue&type=script&lang=js"
export * from "./RenameTaskModal.vue?vue&type=script&lang=js"

import "./RenameTaskModal.vue?vue&type=style&index=0&id=41b56560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b56560"]])

export default __exports__